export default {"src":"/_next/static/media/arrowback.d40685c1.svg","height":224,"width":104,"blurWidth":0,"blurHeight":0};